type CookieState = {
  action: string
  categories?: string[]
} | null

export const cookieState = (): CookieState => {
  const state = (window as Window & { CookieScript?: any }).CookieScript?.instance?.currentState?.()
      ?? null

  if (state?.action !== 'accept') {
    return null
  }

  return state
}

export const hasSelectedPerformanceCookies = (): boolean => cookieState()?.categories?.includes('performance') ?? false
export const hasSelectedFunctionalityCookies = (): boolean => cookieState()?.categories?.includes('functionality') ?? false

/** @see https://help.cookie-script.com/en/articles/30242-custom-events */
const cookieEvents: string[] = [
  'CookieScriptAcceptAll',
  'CookieScriptAccept',
  'CookieScriptReject',
  'CookieScriptClose',
]

export const eventListenerForType = (type: string, closure: () => any) =>
  window.addEventListener(`CookieScriptCategory-${type}`, closure)

export const removeEventListenerForType = (type: string, closure: () => any) =>
  window.removeEventListener(`CookieScriptCategory-${type}`, closure)

export const eventListenerForEvents = (closure: () => any) =>
  cookieEvents.forEach((event) => window.addEventListener(event, closure))

export const removeEventListenerForEvents = (closure: () => any) =>
  cookieEvents.forEach((event) => window.removeEventListener(event, closure))